import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";

import { FaExclamationCircle } from "react-icons/fa";
import { IoCloudDownloadOutline } from "react-icons/io5";

import { ApplicationAction, StudentAction } from "../../store/actions";

import { Spacer, Buttons, Modal, upload } from "..";

import StatusIndicator from "../status-indicator";

import "./styles.css";
import { message } from "antd";

const ApplicationRowInProgress = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const id = location.pathname.split("/")[3];
  const appData = props?.item;

  const [applicationModal, setApplicationModal] = useState(false);
  const [reqLetterModal, setReqLetterModal] = useState(false);
  const [reqLetter, setReqLetter] = useState("");

  const modalData = [
    { title: "University Name", value: appData?.university?.name },
    {
      title: "Date of Submission",
      value: appData?.dateOfApplication
        ? moment(appData?.dateOfApplication).format("DD MMMM, YYYY")
        : "NA",
    },
    { title: "Application Status", value: appData?.status },
    {
      title: "Application Submitted",
      value: appData?.submittedApplication ? "Yes" : "No",
    },
  ];

  const handleRequestLoR = () => {
    if (!reqLetter) {
      message.error("Please upload PDF");
      return;
    }
    const payload = {
      applicationId: appData.id,
      lorReq: false,
      lor: reqLetter,
    };

    dispatch(
      ApplicationAction.reqLOR(payload, (res) => {
        console.log(res);
        if (res.status === 200) {
          setReqLetterModal(false);
          setReqLetter("");
          dispatch(StudentAction.getStudentDetails({ userId: id }));
        }
      })
    );
  };

  const handleApprove = () => {
    const payload = {
      appId: appData.id,
      status: "Accepted",
    };
    dispatch(
      ApplicationAction.changeApplicationStatus(payload, () => {
        dispatch(StudentAction.getStudentDetails({ userId: id }));
      })
    );
  };

  return (
    <div key={props.index} className="application-row-inprogress">
      <div className="flex gap-3 w-full">
        <div className="approw-image-container">
          <img
            src={appData?.university?.profilePic ?? Images.LogoIconOnly}
            className="approw-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = Images.LogoIconOnly;
            }}
          />
        </div>
        <div className="flex flex-col justify-center gap-2 w-[83%]">
          <div className="app-row-heading">
            {appData?.university?.name} Application
          </div>
          <div className="app-row-subheading">{appData?.university?.name}</div>
        </div>
      </div>
      <div className="flex flex-col justify-center gap-2 pl-4">
        <div className="app-row-heading">
          {appData?.university?.deadlines?.length > 0
            ? appData?.university?.deadlines[0].deadlineType ??
              "Application Deadline"
            : "Application Deadline"}
        </div>
        <div className="app-row-subheading">
          {appData?.university?.deadlines?.length > 0
            ? appData?.university?.deadlines[0].appDeadline
              ? moment(appData?.university?.deadlines[0].appDeadline).format(
                  "DD MMMM, YYYY"
                )
              : "NA"
            : "NA"}
        </div>
      </div>

      <div className="flex flex-col justify-center items-center gap-2">
        <div className="app-row-heading">Letter of Recommendation</div>
        <div className="app-row-subheading">
          {appData?.requestedRecLetter && !appData?.recLetter ? (
            <span
              className="text-yellow-400 text-[2em] cursor-pointer"
              onClick={() => setReqLetterModal(true)}
            >
              <FaExclamationCircle />
            </span>
          ) : !appData?.requestedRecLetter && appData?.recLetter ? (
            <span className="rounded-3xl bg-[#72D561] text-white font-medium py-2.5 px-7">
              Sent
            </span>
          ) : (
            <span className="rounded-3xl bg-yellow-400 text-white font-medium p-2.5">
              Not Required
            </span>
          )}
        </div>
      </div>
      {appData?.status?.toLowerCase() === "pending" ? (
        <div className="flex items-center justify-center">
          <Buttons.DefaultButton size="medium" onClick={handleApprove}>
            Approve application
          </Buttons.DefaultButton>
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center gap-2">
          <div className="app-row-heading">Decision</div>
          <div className="app-row-subheading">
            <StatusIndicator
              text={appData?.status}
              color={
                appData?.status?.toLowerCase() === "accepted"
                  ? "green"
                  : appData?.status?.toLowerCase() === "rejected"
                  ? "red"
                  : appData?.status?.toLowerCase() === "waitlisted"
                  ? "blue"
                  : appData?.status?.toLowerCase() === "pending"
                  ? "yellow"
                  : "gray"
              }
              showarrow={false}
            />
          </div>
        </div>
      )}

      <Modal.DefaultModal
        open={applicationModal}
        onCancel={() => setApplicationModal(false)}
        closable
      >
        <div className="flex flex-col items-center justify-center w-[37.5em] p-4">
          <div className="text-[1.625em] font-bold">Application Details</div>
          <Spacer height={20} />
          <div className="flex flex-col gap-2 w-full">
            {modalData?.map((item, index) => (
              <div className="grid grid-cols-2" key={index}>
                <div className="text-left font-semibold text-[1.125em]">
                  {item?.title}
                </div>
                <div className="text-right font-medium text-[1.125em]">
                  {item?.value}
                </div>
              </div>
            ))}
          </div>
          <Spacer height={20} />
          {appData?.submittedApplication && (
            <div className="w-full flex flex-col gap-2">
              <div className="text-left font-semibold text-[1.125em]">
                Proof of Application
              </div>
              <div
                className="border border-dashed border-main rounded-xl p-4 flex justify-center items-center flex-col gap-3 w-full cursor-pointer"
                onClick={() =>
                  window.open(appData?.proofOfApplication, "_blank")
                }
              >
                <IoCloudDownloadOutline className="text-[50px] text-main" />
                <div className="text-[1.125em] text-main font-semibold">
                  Click Here to Download
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal.DefaultModal>
      <Modal.DefaultModal
        open={reqLetterModal}
        onCancel={() => {
          setReqLetterModal(false);
          setReqLetter("");
        }}
        closable
      >
        <div className="flex flex-col items-center justify-center w-[37.5em] p-4">
          <div className="text-[1.625em] font-bold text-main">
            Recommendation Letter Request
          </div>
          <Spacer height={20} />
          <div className="flex flex-col gap-3 w-full justify-left">
            <div className="font-semibold pl-2">Upload PDF</div>
            <upload.DefaultFileUpload
              onChange={(file) => setReqLetter(file)}
              value={reqLetter}
            />
          </div>
          <Spacer height={20} />
          <Buttons.DefaultButton
            onClick={handleRequestLoR}
            disabled={!reqLetter}
          >
            Send
          </Buttons.DefaultButton>
        </div>
      </Modal.DefaultModal>
    </div>
  );
};

export default ApplicationRowInProgress;
